import React, { Component } from 'react';

import Badge from 'material-ui/Badge';
import BadgeIcon from 'material-ui/svg-icons/action/event';
import IconButton from 'material-ui/IconButton';
import { Link } from 'react-router';


class EventBadge extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            count: 0
        };
    }

    render() {
        let style = {
            badge: {},
            container: {
                padding: 0
            },
            icon: {
                padding: 0
            }
        };

        if(this.state.count === 0) {
            style.badge.display = 'none';
        }

        return (
            <Link to="/dashboard/events">
                <Badge 
                    badgeContent={this.state.count} 
                    secondary={true} 
                    style={style.container} 
                    badgeStyle={style.badge}
                >
                    <IconButton style={style.icon} tooltip="events">
                        <BadgeIcon color="white"/>
                    </IconButton>
                </Badge>
            </Link>
        )
    }

}

export default EventBadge;
